import TileHeader from './TileHeader';

export default TileHeader;
